export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-background-950 to-background-900 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-500/20 text-accent-400 text-xs font-semibold mb-4 whitespace-nowrap">
                即将上线
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50">随身吃瓜</h2>
              <p className="mt-4 text-sm md:text-base text-background-300 leading-relaxed max-w-md mx-auto lg:mx-0">
                黑料大赛移动端即将上线，随时随地刷八卦，推送提醒不错过任何一个大瓜。iOS 与 Android 同步开发中，敬请期待。
              </p>
              <div className="mt-6 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                <button className="px-6 py-3 bg-background-50 text-foreground-900 font-semibold rounded-lg hover:bg-background-100 transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer flex items-center gap-2">
                  <i className="ri-apple-line"></i> App Store
                </button>
                <button className="px-6 py-3 bg-accent-500 text-background-950 font-semibold rounded-lg hover:bg-accent-400 transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer flex items-center gap-2">
                  <i className="ri-android-line"></i> Google Play
                </button>
              </div>
              <p className="mt-4 text-xs text-background-500">现在订阅邮箱快讯，上线第一时间通知你</p>
            </div>
            <div className="flex-1 p-6 md:p-0">
              <img
                src="https://readdy.ai/api/search-image?query=Sleek%20modern%20smartphone%20mockup%20displaying%20dark%20theme%20entertainment%20news%20app%20interface%20with%20warm%20red%20accents%2C%20clean%20UI%20design%2C%20floating%20phone%20on%20gradient%20background%2C%20product%20shot%20style%2C%20no%20recognizable%20text&width=500&height=600&seq=app-mockup&orientation=portrait"
                alt="黑料大赛移动端预览"
                className="w-full max-w-xs mx-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}